import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ThankYou from './views/ThankYou.vue'
import ConfirmedPage from './views/ConfirmedPage.vue'
import ConfirmationExpiredPage from './views/ConfirmationExpiredPage.vue';


Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/thank-you',
            name: 'thanks',
            component: ThankYou
        },
        {
            path: '/confirmed',
            name: 'confirmed',
            component: ConfirmedPage
        },
        {
            path: '/confirmation-expired',
            name: 'confirmation-expired',
            component: ConfirmationExpiredPage
        },
        {
            path: '/',
            name: 'home',
            component: Home
        }
    ]
})
